import { OfflineAppointment } from "../../firestore/types";
import { getIdb } from "../../utils/bridges/methods";

// bulkPut of dexie under the hood upserts only
export async function bulkPutAppointments(
  appointments: OfflineAppointment[]
): Promise<void> {
  if (appointments.length === 0) return;
  await getIdb().appointments.bulkPut(appointments);
}
